import { FormState } from "./FormState";
import {crearServicioTransporte, NuevoServicioTransporte, TipoTrayectoTransporte} from "../../../services/transporteServicios";
import {parseCurrency} from "../../../utils/numberUtils";

const generarNuevoServicioTransporte = (formState: FormState): NuevoServicioTransporte => {
    return {
        nombre: formState.nombre.value,
        descripcion: formState.descripcion.wasTouched ? formState.descripcion.value : undefined,
        idSector: formState.sector.wasTouched ? formState.sector.value : undefined,
        precio: parseCurrency(formState.precio.value, "$", ","),
        tipoTrayecto: formState.tipoTrayecto.value as TipoTrayectoTransporte
    }
}

export const crearNuevoServicioTransporte = async (formState: FormState) => {
    const nuevoServicio = generarNuevoServicioTransporte(formState);
    await crearServicioTransporte(nuevoServicio);
}